import { useEffect, useState } from "react";

export const cx = (...classes) => classes.filter(Boolean).join(" ");

export function useScrollSpy(sectionIds, offset = 120) {
  const [active, setActive] = useState(sectionIds[0] ?? "");

  useEffect(() => {
    const elements = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
    if (!elements.length) return;

    const handler = () => {
      const y = window.scrollY + offset;
      let current = sectionIds[0];

      for (const element of elements) {
        if (element.offsetTop <= y) current = element.id;
      }

      setActive(current);
    };

    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, [sectionIds, offset]);

  return active;
}

export function scrollToId(id) {
  const element = document.getElementById(id);
  if (!element) return;
  element.scrollIntoView({ behavior: "smooth", block: "start" });
}
